import { FC } from "react";
import { Col } from "reactstrap";
import getFieldComponent, { Collapsed, IFormProps } from ".";
import { FormViewModel } from "../Models";
import BaseViewModel from "../Models/BaseViewModel";
import { DescriptorKeyType } from "../Types";

interface IForm extends IFormProps {
	model: FormViewModel;
	pageIndex?: number;
};

const FormControl: FC<IForm> = ( props ) => {

	const { model, readOnly, setFieldValue, pageIndex } = props;

	const isContainer = ( part: BaseViewModel ) => part.DescriptorKey === "CollectionFormDescriptor";

	const renderFormPart = ( part: BaseViewModel, index: number ) => {
		const isReadOnly = !part.ControlEnabling || readOnly;
		const Control = getFieldComponent( part.DescriptorKey as DescriptorKeyType );
		const ctrlProps = {
			model: part,
			readOnly: isReadOnly,
			setFieldValue,
			allowScan: !!BaseViewModel.scanSettings && (!!BaseViewModel.scanSettings.scanModuleInstallUrl || !!BaseViewModel.scanSettings.scanModuleWorkUrl),
			pageIndex
		};
		if ( isContainer(part) )
			return <Control key={"FormControl_" + index} {...ctrlProps} />;
		else 
			return (
				<Col md={part.Width ?? 12} key={part.LocalPath}>
					<Control {...ctrlProps} />
				</Col>
			);
	};

	return (
		<Collapsed {...props} defaultOpen hidden={!model.ControlVisibility}>
			{ model.FormElements.map( renderFormPart ) }
		</Collapsed>
	);
};

export default FormControl;
